/* js/components/socialShare/ShareButton.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	attr,
	create_slot,
	detach,
	element,
	get_all_dirty_from_scope,
	get_slot_changes,
	init,
	insert,
	safe_not_equal,
	set_data,
	space,
	text,
	toggle_class,
	transition_in,
	transition_out,
	update_slot_base
} from "svelte/internal";

function create_fragment(ctx) {
	let a;
	let div1;
	let div0;
	let t0;
	let t1;
	let div1_class_value;
	let current;
	const default_slot_template = /*#slots*/ ctx[6].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[5], null);

	return {
		c() {
			a = element("a");
			div1 = element("div");
			div0 = element("div");
			if (default_slot) default_slot.c();
			t0 = space();
			t1 = text(/*label*/ ctx[1]);
			attr(div0, "aria-hidden", "true");
			attr(div0, "class", "ssbc-button__icon svelte-abzkh4");
			toggle_class(div0, "ssbc-button__icon--fill", /*fill*/ ctx[2]);
			toggle_class(div0, "ssbc-button__icon--outline", !/*fill*/ ctx[2]);
			attr(div1, "class", div1_class_value = "ssbc-button " + /*classes*/ ctx[4] + " svelte-abzkh4");
			attr(a, "class", "ssbc-button__link svelte-abzkh4");
			attr(a, "href", /*href*/ ctx[0]);
			attr(a, "target", "_blank");
			attr(a, "rel", "noopener");
			attr(a, "aria-label", /*ariaLabel*/ ctx[3]);
		},
		m(target, anchor) {
			insert(target, a, anchor);
			append(a, div1);
			append(div1, div0);

			if (default_slot) {
				default_slot.m(div0, null);
			}

			append(div1, t0);
			append(div1, t1);
			current = true;
		},
		p(ctx, [dirty]) {
			if (default_slot) {
				if (default_slot.p && (!current || dirty & /*$$scope*/ 32)) {
					update_slot_base(
						default_slot,
						default_slot_template,
						ctx,
						/*$$scope*/ ctx[5],
						!current
						? get_all_dirty_from_scope(/*$$scope*/ ctx[5])
						: get_slot_changes(default_slot_template, /*$$scope*/ ctx[5], dirty, null),
						null
					);
				}
			}

			if (dirty & /*fill*/ 4) {
				toggle_class(div0, "ssbc-button__icon--fill", /*fill*/ ctx[2]);
			}

			if (dirty & /*fill*/ 4) {
				toggle_class(div0, "ssbc-button__icon--outline", !/*fill*/ ctx[2]);
			}

			if (!current || dirty & /*label*/ 2) set_data(t1, /*label*/ ctx[1]);

			if (!current || dirty & /*classes*/ 16 && div1_class_value !== (div1_class_value = "ssbc-button " + /*classes*/ ctx[4] + " svelte-abzkh4")) {
				attr(div1, "class", div1_class_value);
			}

			if (!current || dirty & /*href*/ 1) {
				attr(a, "href", /*href*/ ctx[0]);
			}

			if (!current || dirty & /*ariaLabel*/ 8) {
				attr(a, "aria-label", /*ariaLabel*/ ctx[3]);
			}
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(a);
			if (default_slot) default_slot.d(detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { $$slots: slots = {}, $$scope } = $$props;
	let { href } = $$props;
	let { label = '' } = $$props;
	let { fill = true } = $$props;
	let { ariaLabel = '' } = $$props;
	let { class: classes = '' } = $$props;

	$$self.$$set = $$props => {
		if ('href' in $$props) $$invalidate(0, href = $$props.href);
		if ('label' in $$props) $$invalidate(1, label = $$props.label);
		if ('fill' in $$props) $$invalidate(2, fill = $$props.fill);
		if ('ariaLabel' in $$props) $$invalidate(3, ariaLabel = $$props.ariaLabel);
		if ('class' in $$props) $$invalidate(4, classes = $$props.class);
		if ('$$scope' in $$props) $$invalidate(5, $$scope = $$props.$$scope);
	};

	return [href, label, fill, ariaLabel, classes, $$scope, slots];
}

class ShareButton extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			href: 0,
			label: 1,
			fill: 2,
			ariaLabel: 3,
			class: 4
		});
	}
}

export default ShareButton;